import React from 'react';

import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useProductAR from 'data-hooks/useProductAR';
import useProductAttributes from 'data-hooks/useProductAttributes';
import PDPView3DButtonUI from './PDPView3DButtonUI';

const PDPView3DButton = () => {
  const { loading, data: basicDetailsData = {} } = usePDPBasicDetails();

  const { name: productName } = basicDetailsData;

  const {
    data: { arAsset, arAssetUpholstery, arPrice },
  } = useProductAR();

  const { data: attributesData } = useProductAttributes();

  const banner = `#callToAction=Close&checkoutTitle=${encodeURIComponent(
    productName
  )}`.concat(
    arAssetUpholstery
      ? `&checkoutSubtitle=${encodeURIComponent(
          `Shown in ${arAssetUpholstery}`
        )}`
      : '',
    `&price=$${arPrice}`
  );
  const url = arAsset
    ? `${arAsset}${banner}&canonicalWebPageURL=${attributesData?.SEOAttributes?.canonicalURL}&allowsContentScaling=0`
    : undefined;

  if (loading || !arAsset) {
    return null;
  }

  return <PDPView3DButtonUI url={url} />;
};

export default PDPView3DButton;
